import { render } from "./DefaultOSCMailTexts.vue?vue&type=template&id=3072169c"
import script from "./DefaultOSCMailTexts.vue?vue&type=script&lang=js"
export * from "./DefaultOSCMailTexts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__